import { useEffect, useState } from 'react';
import {
  resolveRuntimeEnvironment,
  type RuntimeEnvironmentInfo,
} from '@/lib/runtimeEnvironment';

const FALLBACK: RuntimeEnvironmentInfo = resolveRuntimeEnvironment({
  useMock: false,
  isDev: import.meta.env.DEV,
});

export function useRuntimeEnvironment(): RuntimeEnvironmentInfo {
  const [info, setInfo] = useState<RuntimeEnvironmentInfo>(() =>
    resolveRuntimeEnvironment({
      useMock: false,
      isDev: import.meta.env.DEV,
      explicitEnv: import.meta.env.VITE_RUNTIME_ENV,
    }),
  );

  useEffect(() => {
    let cancelled = false;
    const cacheBust = import.meta.env.DEV ? `?t=${Date.now()}` : '';
    void fetch(`/amplify_outputs.json${cacheBust}`, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : null))
      .then((outputs) => {
        if (cancelled) return;
        setInfo(
          resolveRuntimeEnvironment({
            useMock: false,
            userPoolId: outputs?.auth?.user_pool_id as string | undefined,
            isDev: import.meta.env.DEV,
            explicitEnv: import.meta.env.VITE_RUNTIME_ENV,
          }),
        );
      })
      .catch(() => {
        if (!cancelled) setInfo(FALLBACK);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return info;
}
